<div class="backdrop" (click)="onClose()"></div>
<div class="help-box">
    <div class="help-header">
        <p>Help</p>
        <em class="material-icons" (click)="onClose()">close</em>
    </div>

    <div class="help-box-content">
        <h3 class="c-hdg c-hdg_4 d-inline">Claim CME/CE Credit for Faxed AP Results</h3>

        <div class="mt-3" [innerHTML]="contextualHelpHTML"></div>
        <button class="btn btn-primary" (click)="onClose()">Close</button>
    </div>
</div>
